import React from "react";
import { Fullscreen, FullscreenExit } from "@mui/icons-material";
import useTranslations from "./useLanguageHook";
import { ResponsiveButton } from "../Components/ResponsiveButton";

/**
 * Function to request fullscreen for ref object
 *
 * Attach it like this:
 *
 *     const elementRef = React.useRef<undefined | HTMLDivElement>(undefined);
 *     <div ref={elementRef}/>
 *     <Button onclick={() => toggleFullscreen(elementRef))}/>
 *
 * @param elem React.useRef object
 */
export function toggleFullscreen(elem: React.MutableRefObject<HTMLDivElement | undefined>) {
  if (!document.fullscreenElement && elem.current) {
    elem.current.requestFullscreen();
  } else {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    }
  }
}

export function FullscreenButton({ elementRef }: { elementRef: React.MutableRefObject<HTMLDivElement | undefined> }) {
  const { t } = useTranslations();
  return (
    <ResponsiveButton
      color="secondary"
      text={document.fullscreenElement ? t.Options.FullscreenCloseShort : t.Options.FullscreenOpenShort}
      tooltip={document.fullscreenElement ? t.Options.FullscreenClose : t.Options.FullscreenOpen}
      icon={document.fullscreenElement ? <FullscreenExit /> : <Fullscreen />}
      variant="contained"
      onClick={() => toggleFullscreen(elementRef)}
    />
  );
}
